import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, List } from '../../../../../../components/UI/ComponentsUI';
import { translate } from '../../../../../../utils/util';
import { ENUMS } from '../../../../../../utils/constants';
import * as loweringDeliveryAction from '../../../../../../actions/loweringDeliveryAction';

const OrdersList = (props) => {
    const [orders, setOrders] = useState([]);

    const subtitles = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filterByPartnumber') }];
    }

    useEffect(() => {
        if (props.orders?.length > 0) {
            const ordersFilter = props.orders.filter((order) => order.status !== ENUMS.eOrderStatus.Canceled.value
                && order.status !== ENUMS.eOrderStatus.Finished.value
                && order.status !== ENUMS.eOrderStatus.ManuallyFinished.value
                && order.status !== ENUMS.eOrderStatus.WaitingFinish.value);
            setOrders(ordersFilter);
        } else {
            setOrders([]);
        }
        // eslint-disable-next-line
    }, [props?.orders]);

    const onSelectChange = (event) => {
        props.setOrder(event);
        props.history.push({
            pathname: `../loweringDelivery/startDelivery/order/missions/${event.items[0].orderItemId}`
        });
    };

    return (
        <div>
            <Breadcrumbs id="OrdersListFilter" title={{ icon: "mdi mdi-cart-check", label: translate('title', 'delivery') }} subtitles={subtitles()} />
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <div id="listOrdersDeliveryFilter">
                    <List
                        data={orders.map((item) => (
                            <div
                                className="row"
                                style={{ display: 'block', marginBottom: '0px', marginLeft: '5px' }}
                                onClick={() => {
                                    onSelectChange(item);
                                }}
                            >
                                <span className="title sixth-text-color" style={{ marginLeft: '10px', display: 'block' }} >
                                    {`${item.items[0].partnumber || '-'}`}
                                </span>
                                <span className="title sixth-text-color" style={{ marginLeft: '10px', display: 'block' }} >
                                    {`${item.orderCode || '-'}`}
                                </span>
                                <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }} >
                                    <span className="bold">{translate('picking.cim', 'expedition')}:</span> {`${item?.items[0]?.cim || '-'}`}
                                </span>
                                <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>
                                    <span className="bold">{translate('fields.destination', 'delivery')}:</span> {`${item?.items[0]?.nextLocation || '-'}`}
                                </span>
                                <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }} >
                                    <span className="bold">{translate('linepicking.route', 'line-picking')}:</span> {item.route?.code || "-"}
                                </span>
                            </div>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        orders: state.loweringDeliveryReducer.orders
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOrder: (order) => {
            dispatch(loweringDeliveryAction.setOrder(order));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OrdersList)));
